<!--
 * @Author: houmy
 * @Date: 2023-09-21 11:35:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-01 14:57:47
 * @FilePath: \zx-home\src\views\SolutionDetail.vue
 * @Description: 
 * 
-->

<template>
    <div class="page">
        <Contact ref="Contact"></Contact>

        <div class="productDetailBanner">
            <img class="productDetailBannerImg" :src="getImagePath(detail.banner)" alt="">
            <div class="bannerMain">
                <div class="detailBannerInfo solutionBannerInfo" :class="[detail.bannerColorWhite ? 'whiteText' : '']">
                    <h1>{{ detail.title }}</h1>
                    <p>{{ detail.desc }}</p>
                           <button class="commonBtn toContact detailContact" @click="onlineContact">
                            <img src="../assets/img/contact2.png" alt="">产品咨询
                        </button>
                </div>
            </div>
        </div>
        <div class="levelWrap" v-if="detail.workLevelImg">
            <div class="home-title detail-title" style="margin-top: 70px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese whiteText">农机自动驾驶作业分级</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Classification of Agricultural Machinery Autonomous Driving Operations'.toUpperCase() }}</span>

            </div>
            <img class="descPic-bg" :src="getImagePath(detail.workLevelImg)" alt="">
        </div>
        <div class="levelWrap" v-if="detail.system">
            <div class="home-title detail-title" style="margin-top: 90px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese whiteText">农场管理信息平台</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Agricultural Farm Management System'.toUpperCase() }}</span>
            </div>
            <div class="descWrap">
                <p class="detailDesc  whiteText">{{ detail.system.desc }}</p>
                <p class="detailDesc  whiteText">{{ detail.system.desc2 }}</p>
            </div>
            <img class="descPic-bg" :src="getImagePath(detail.system.img)" alt="">
        </div>

        <div v-if="detail.chsaaisInfo" class="lightWrap">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese blackText">底盘电控化</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Chassis Electrification'.toUpperCase() }}</span>

            </div>
            <div class="descWrap">
                <p class="detailDesc">{{ detail.chsaaisInfo.desc }}</p>
                <p class="detailDesc">{{ detail.chsaaisInfo.desc2 }}</p>
            </div>

            <ul class="chsaaisList  w12">
                <li v-for="item in detail.chsaaisInfo.list">
                    <img :src="getImagePath(item.img)" alt="">
                    <div class="textMain">
                        <b>{{ item.title }}</b>
                        <p>{{ item.info }}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="levelWrap" v-if="detail.agriculturalInfo">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese">农情监测</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Agricultural Monitoring'.toUpperCase() }}</span>
            </div>
            <img class="descPic-bg" :src="getImagePath(detail.agriculturalInfo.bgImg)" alt="">
            <div class="w12 argCenter justify-between">
                <ul class="monitorList">
                    <li class="flex-row" v-for="item in detail.agriculturalInfo.list">
                        <img :src="getImagePath(item.img)" alt="">
                      <div class="monitorMain">
                        <b>
                            {{ item.title }}
                        </b>
                        <p>{{ item.info }}</p>
                      </div>
                    </li>
                </ul>
                <!-- <label class="label1">气象站</label>
                <label class="label2">土壤监测站</label>
                <label class="label3">虫情测报仪</label>
                <label class="label4">孢子分析仪</label>
                <label class="label5">农业监测系统</label> -->
                <img class="mointorDetailImg" :src="getImagePath(detail.agriculturalInfo.img)" alt="">
            </div>
        </div>

        <div v-if="detail.smartInfo" class="smartWrap">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese whiteText">智能感知</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Smart Perception'.toUpperCase() }}</span>

            </div>
            <div class="descWrap">
                <p class="detailDesc">{{ detail.smartInfo.desc }}</p>
                <p class="detailDesc">{{ detail.smartInfo.desc2 }}</p>
            </div>

            <ul class="chsaaisList  w12">
                <li v-for="item in detail.smartInfo.list">
                    <img :src="getImagePath(item.img)" alt="">
                    <div class="textMain">
                        <b>{{ item.title }}</b>
                        <p>{{ item.info }}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div v-if="detail.remote" class="levelWrap">
            <div class="home-title detail-title" style="margin-top: 90px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese whiteText">远程调度</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Remote Dispatch'.toUpperCase() }}</span>

            </div>
            <div class="descWrap">
                <p class="detailDesc whiteText">{{ detail.remote.desc }}</p>
                <p class="detailDesc whiteText">{{ detail.remote.desc2 }}</p>
            </div>
            <img class="descPic-bg" :src="getImagePath(detail.remote.img)" alt="">
        </div>

        <div class="levelWrap" v-if="detail.auto">
            <div class="home-title detail-title" style="margin-top: 90px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese blackText">自动驾驶作业决策控制</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Autonomous Driving Operation Decision Control'.toUpperCase() }}</span>

            </div>
            <div class="descWrap">
                <p class="detailDesc">{{ detail.auto.desc }}</p>
                <p class="detailDesc">{{ detail.auto.desc2 }}</p>
            </div>
            <img class="descPic-bg" :src="getImagePath(detail.auto.img)" alt="">
        </div>
        <div class="levelWrap" v-if="detail.digital" style="height: 1010px;">
            <div class="home-title detail-title" style="margin-top: 70px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese blackText">数字农场高精度地图基础设施</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Digital Farm High-Precision Map Infrastructure'.toUpperCase() }}</span>

            </div>
            <div class="descWrap">
                <p class="detailDesc">{{ detail.digital.desc }}</p>
                <p class="detailDesc">{{ detail.digital.desc2 }}</p>
            </div>
            <img class="descPic-bg" :src="getImagePath(detail.digital.img)" alt="">
        </div>

        <div v-if="detail.pathInfo" class="pathWrap">
            <div class="home-title detail-title" style="margin-top: 148px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese blackText">路径规划</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Path Planning'.toUpperCase() }}</span>

            </div>
            <div class="descWrap">
                <p class="detailDesc">{{ detail.pathInfo.desc }}</p>
                <p class="detailDesc">{{ detail.pathInfo.desc2 }}</p>
            </div>

            <ul class="chsaaisList  w12">
                <li v-for="item in detail.pathInfo.list">
                    <img :src="getImagePath(item.img)" alt="">
                    <div class="textMain">
                        <b>{{ item.title }}</b>
                        <p>{{ item.info }}</p>
                    </div>
                </li>
            </ul>
        </div>

        <div class="levelWrap" v-if="detail.integration">
            <div class="home-title detail-title" style="margin-top: 90px;">
                <div class="title-divider">
                    <img src="@/assets/img/title-left.png" alt="Divider" />
                    <span class="title-chinese blackText">农机农艺融合</span>
                    <img src="@/assets/img/title-right.png" alt="Divider" />
                </div>
                <span class="title-english">{{ 'Integration of Agricultural Machinery and Agronomy'.toUpperCase() }}</span>

            </div>
            <div class="descWrap">
                <p class="detailDesc">{{ detail.integration.desc }}</p>
                <p class="detailDesc">{{ detail.integration.desc2 }}</p>
            </div>
            <img class="descPic-bg" :src="getImagePath(detail.integration.img)" alt="">
        </div>




    </div>
</template>
    
<script>
import Contact from '../components/Contact.vue'
import solutionJson from '@/assets/data/solution.json'

export default {
    components: {
        Contact
    },
    data() {
        return {
            allSolutions: [],
            detail: {},
        };
    },
    watch: {
        '$route'(val, from) {
            if (val.query.id) {
                this.id = this.$route.query.id;
                this.detail = this.allSolutions.find(item => item.id == this.id)
            }
        }
    },
    mounted() {
        this.allSolutions = solutionJson
        this.id = this.$route.query.id;
        this.detail = this.allSolutions.find(item => item.id == this.id)
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
    },

    methods: {
        // 产品咨询
        onlineContact() {
            this.$refs.Contact.handleShowContact()
        },

        // 图片回显
        getImagePath(imageName) {
            return require(`@/assets${imageName}`);
        }



    }
};
</script>
    
<style scoped></style>
    


// WEBPACK FOOTER //
// src/views/SolutionDetail.vue